<mat-grid-list rowHeight="fit" id="dialer-grid" cols="3">
  <mat-grid-tile *ngFor="let button of dialerButtons">
    <button id="dialer-btn-{{button.text}}" mat-button (click)="onClick(button.text)">
      <div style="text-align: center" fxLayout="column">
        <div>{{button.text}}</div>
        <div class="dialer-subText" [innerHtml]="button.subText"></div>
      </div>
    </button>
  </mat-grid-tile>
</mat-grid-list>
